module.exports = __webpack_public_path__ + "static/img/bg-tit3.6e233c4a.png";